import React, { memo, useState, useEffect } from 'react';
import { Grid, Card } from '@material-ui/core';
import logo from 'components/Logo/logo-dermpro.svg';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link, useParams } from 'react-router-dom';


const useStyles = makeStyles(() => ({
  textHyphenation: {
    hyphens: 'auto',
  }
}));

const Brands = ({results, debouncedSearchItem, brandsType}) => {
  const [searchResults, setSearchResults] = useState(results);
  const classes = useStyles();
  const { storeView } = useParams<{storeView: string}>();

  useEffect(() => {
    if (debouncedSearchItem) {
      setSearchResults(results.filter((brand) =>
        brand.value.toLowerCase().includes(debouncedSearchItem)
      ));
    } else {
      setSearchResults(results);
    }
  }, [debouncedSearchItem, results]);

  return (
    <Grid container spacing={4}>
      {searchResults && searchResults.map((brand, idx) => {
        if (brand.option_id) {
          return (
            <Grid item md={2} sm={4} xs={6} key={idx}>
              <Link to={`/browse-brand/${storeView}/${brand.option_id}/${brandsType}`}>
                <Card elevation={25} className={clsx('text-center min-h-200')}>
                  <img
                    src={brand.image !== '' ? `${brand.image}` : logo}
                    alt={brand.value}
                    width="100%"
                    className={clsx('p-4 max-h-100')}
                    onError={(e) => {
                      (e.target as HTMLImageElement).onerror = null;
                      (e.target as HTMLImageElement).src = logo;
                    }}
                  />
                  <p className={clsx('text-brand font-bold p-2 text-center min-h-60', classes.textHyphenation)}>{brand.value}</p>
                </Card>
              </Link>
            </Grid>
          );
        }

        return null;
      })}
    </Grid>

  );
};

function brandsPropsAreEqual(prevProp, nextProp) {
  return prevProp.results.length === nextProp.results.length
    && prevProp.debouncedSearchItem === nextProp.debouncedSearchItem;
}

export default memo(Brands, brandsPropsAreEqual);
